<template>
  <div class="cell" :class="{active: gameActive}" @click="markCell">
      <span class="mark" v-if="state !== 'empty'">{{ state }}</span>
  </div>
</template>

<script>
export default {
    name: 'TicTacToeCell',

    props: {
        currentPlayer: {
            validator: function(value) {
                return ['x', 'o'].indexOf(value.toLowerCase()) !== -1;
            },
            required: true,
        },
        gameActive: Boolean,
    },

    data() {
        return {
            state: 'empty',
        };
    },

    methods: {
        markCell() {
            if (this.state !== 'empty' || !this.gameActive) return;
            this.state = this.currentPlayer;
            this.$emit('cellMarked');
        }
    }
}
</script>

<style>
.cell {
  display: inline-block;
  position: relative;
  width: 100px;
  height: 100px;
  margin: 5px;
  border: 1px solid black;
}

.active:hover {
    border: 2px solid black;
    margin: 4px;
}

.mark {
    position: absolute;
}
</style>